const NON_BREAKING_SPACE = '\u00A0';

export default function preventOrphan(input: string) {
  const parts = input.split(' ');

  if (parts.length === 1) {
    return parts;
  }

  return `${parts.slice(0, parts.length - 1).join(' ')}${NON_BREAKING_SPACE}${parts[parts.length - 1]}`;
}